import googleMapUtil from './mapUtil';
import hereMapUtil from '../../map-here/js/mapUtil';
import { getStore } from '@/store';

export default function useMapUtil() {
    let mapType = getStore('page').page?.map?.type || 'here'
    const mapUtil = mapType === 'here' ? hereMapUtil : googleMapUtil;
    return mapUtil;
}